import React from 'react';
import { Button } from "@/components/ui/button";
import { ArrowRight, MapPin } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function Hero() {
  const navigate = useNavigate();

  return (
    <div className="relative h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat transform scale-105 animate-float"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1711797750174-c3750dd9d7c9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxTaWdpcml5YSUyMExpb24lMjBSb2NrfGVufDB8fHx8MTc2MzgzNzkzOHww&ixlib=rb-4.1.0&q=85')`,
        }}
      />
      
      {/* Overlay Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60" />

      {/* Content */}
      <div className="relative container mx-auto h-full flex flex-col justify-center items-center text-center px-4 pt-20">
        <div className="animate-fade-in-up space-y-6 max-w-4xl">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white text-sm font-medium mb-4">
            <span className="w-2 h-2 rounded-full bg-secondary animate-pulse" />
            Discover the Wonder of Asia
          </div>
          
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-serif font-bold text-white leading-tight text-shadow-lg">
            ලංකාවට ඇවිත් බලමු
            <span className="block text-3xl md:text-5xl mt-4 font-light opacity-90">
              (Let's Come and See Sri Lanka)
            </span>
          </h1>
          
          <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto font-light leading-relaxed text-shadow-sm">
            Explore ancient fortresses, pristine beaches, and lush tea plantations. 
            Experience the warmth of our culture and the beauty of our island home.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
            <Button 
              size="lg" 
              className="bg-secondary hover:bg-secondary/90 text-secondary-foreground font-serif text-lg px-8 rounded-full h-14"
              onClick={() => navigate('/booking')}
            >
              Plan Your Journey
            </Button>
            <Button 
              size="lg" 
              variant="outline" 
              className="bg-white/10 hover:bg-white/20 text-white border-white/30 font-serif text-lg px-8 rounded-full h-14 backdrop-blur-sm"
              onClick={() => document.getElementById('destinations').scrollIntoView({ behavior: 'smooth' })}
            >
              View Destinations
            </Button>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce text-white/80">
          <div className="w-6 h-10 rounded-full border-2 border-white/50 flex justify-center pt-2">
            <div className="w-1 h-2 bg-white rounded-full" />
          </div>
        </div>
      </div>
    </div>
  );
}
